/*
File generated by js-routes 1.4.14
Based on Rails 5.2.7 routes of Ibook::Application
 */

(function() {
  var DeprecatedGlobbingBehavior, NodeTypes, ParameterMissing, ReservedOptions, SpecialOptionsKey, UriEncoderSegmentRegex, Utils, error, result,
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  ParameterMissing = function(message, fileName, lineNumber) {
    var instance;
    instance = new Error(message, fileName, lineNumber);
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    } else {
      instance.__proto__ = this.__proto__;
    }
    if (Error.captureStackTrace) {
      Error.captureStackTrace(instance, ParameterMissing);
    }
    return instance;
  };

  ParameterMissing.prototype = Object.create(Error.prototype, {
    constructor: {
      value: Error,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ParameterMissing, Error);
  } else {
    ParameterMissing.__proto__ = Error;
  }

  NodeTypes = {"GROUP":1,"CAT":2,"SYMBOL":3,"OR":4,"STAR":5,"LITERAL":6,"SLASH":7,"DOT":8};

  DeprecatedGlobbingBehavior = false;

  SpecialOptionsKey = "_options";

  UriEncoderSegmentRegex = /[^a-zA-Z0-9\-\._~!\$&'\(\)\*\+,;=:@]/g;

  ReservedOptions = ['anchor', 'trailing_slash', 'subdomain', 'host', 'port', 'protocol'];

  Utils = {
    configuration: {
      prefix: "",
      default_url_options: {},
      special_options_key: "_options",
      serializer: null
    },
    default_serializer: function(object, prefix) {
      var element, i, j, key, len, prop, s;
      if (prefix == null) {
        prefix = null;
      }
      if (object == null) {
        return "";
      }
      if (!prefix && !(this.get_object_type(object) === "object")) {
        throw new Error("Url parameters should be a javascript hash");
      }
      s = [];
      switch (this.get_object_type(object)) {
        case "array":
          for (i = j = 0, len = object.length; j < len; i = ++j) {
            element = object[i];
            s.push(this.default_serializer(element, prefix + "[]"));
          }
          break;
        case "object":
          for (key in object) {
            if (!hasProp.call(object, key)) continue;
            prop = object[key];
            if ((prop == null) && (prefix != null)) {
              prop = "";
            }
            if (prop != null) {
              if (prefix != null) {
                key = prefix + "[" + key + "]";
              }
              s.push(this.default_serializer(prop, key));
            }
          }
          break;
        default:
          if (object != null) {
            s.push((encodeURIComponent(prefix.toString())) + "=" + (encodeURIComponent(object.toString())));
          }
      }
      if (!s.length) {
        return "";
      }
      return s.join("&");
    },
    serialize: function(object) {
      var custom_serializer;
      custom_serializer = this.configuration.serializer;
      if ((custom_serializer != null) && this.get_object_type(custom_serializer) === "function") {
        return custom_serializer(object);
      } else {
        return this.default_serializer(object);
      }
    },
    clean_path: function(path) {
      var last_index;
      path = path.split("://");
      last_index = path.length - 1;
      path[last_index] = path[last_index].replace(/\/+/g, "/");
      return path.join("://");
    },
    extract_options: function(number_of_params, args) {
      var last_el, options;
      last_el = args[args.length - 1];
      if ((args.length > number_of_params && last_el === void 0) || ((last_el != null) && "object" === this.get_object_type(last_el) && !this.looks_like_serialized_model(last_el))) {
        options = args.pop() || {};
        delete options[this.configuration.special_options_key];
        return options;
      } else {
        return {};
      }
    },
    looks_like_serialized_model: function(object) {
      return !object[this.configuration.special_options_key] && ("id" in object || "to_param" in object);
    },
    path_identifier: function(object) {
      var property;
      if (object === 0) {
        return "0";
      }
      if (!object) {
        return "";
      }
      property = object;
      if (this.get_object_type(object) === "object") {
        if ("to_param" in object) {
          if (object.to_param == null) {
            throw new ParameterMissing("Route parameter missing: to_param");
          }
          property = object.to_param;
        } else if ("id" in object) {
          if (object.id == null) {
            throw new ParameterMissing("Route parameter missing: id");
          }
          property = object.id;
        } else {
          property = object;
        }
        if (this.get_object_type(property) === "function") {
          property = property.call(object);
        }
      }
      return property.toString();
    },
    clone: function(obj) {
      var attr, copy, key;
      if ((obj == null) || "object" !== this.get_object_type(obj)) {
        return obj;
      }
      copy = obj.constructor();
      for (key in obj) {
        if (!hasProp.call(obj, key)) continue;
        attr = obj[key];
        copy[key] = attr;
      }
      return copy;
    },
    merge: function() {
      var tap, xs;
      xs = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      tap = function(o, fn) {
        fn(o);
        return o;
      };
      if ((xs != null ? xs.length : void 0) > 0) {
        return tap({}, function(m) {
          var j, k, len, results, v, x;
          results = [];
          for (j = 0, len = xs.length; j < len; j++) {
            x = xs[j];
            results.push((function() {
              var results1;
              results1 = [];
              for (k in x) {
                v = x[k];
                results1.push(m[k] = v);
              }
              return results1;
            })());
          }
          return results;
        });
      }
    },
    normalize_options: function(parts, required_parts, default_options, actual_parameters) {
      var i, j, key, len, options, part, parts_options, result, route_parts, url_parameters, use_all_parts, value;
      options = this.extract_options(parts.length, actual_parameters);
      if (actual_parameters.length > parts.length) {
        throw new Error("Too many parameters provided for path");
      }
      use_all_parts = actual_parameters.length > required_parts.length;
      parts_options = {};
      for (key in options) {
        if (!hasProp.call(options, key)) continue;
        use_all_parts = true;
        if (this.indexOf(parts, key) >= 0) {
          parts_options[key] = value;
        }
      }
      options = this.merge(this.configuration.default_url_options, default_options, options);
      result = {};
      url_parameters = {};
      result['url_parameters'] = url_parameters;
      for (key in options) {
        if (!hasProp.call(options, key)) continue;
        value = options[key];
        if (this.indexOf(ReservedOptions, key) >= 0) {
          result[key] = value;
        } else {
          url_parameters[key] = value;
        }
      }
      route_parts = use_all_parts ? parts : required_parts;
      i = 0;
      for (j = 0, len = route_parts.length; j < len; j++) {
        part = route_parts[j];
        if (i < actual_parameters.length) {
          if (!parts_options.hasOwnProperty(part)) {
            url_parameters[part] = actual_parameters[i];
            ++i;
          }
        }
      }
      return result;
    },
    build_route: function(parts, required_parts, default_options, route, full_url, args) {
      var options, parameters, result, url, url_params;
      args = Array.prototype.slice.call(args);
      options = this.normalize_options(parts, required_parts, default_options, args);
      parameters = options['url_parameters'];
      result = "" + (this.get_prefix()) + (this.visit(route, parameters));
      url = Utils.clean_path(result);
      if (options['trailing_slash'] === true) {
        url = url.replace(/(.*?)[\/]?$/, "$1/");
      }
      if ((url_params = this.serialize(parameters)).length) {
        url += "?" + url_params;
      }
      url += options.anchor ? "#" + options.anchor : "";
      if (full_url) {
        url = this.route_url(options) + url;
      }
      return url;
    },
    visit: function(route, parameters, optional) {
      var left, left_part, right, right_part, type, value;
      if (optional == null) {
        optional = false;
      }
      type = route[0], left = route[1], right = route[2];
      switch (type) {
        case NodeTypes.GROUP:
          return this.visit(left, parameters, true);
        case NodeTypes.STAR:
          return this.visit_globbing(left, parameters, true);
        case NodeTypes.LITERAL:
        case NodeTypes.SLASH:
        case NodeTypes.DOT:
          return left;
        case NodeTypes.CAT:
          left_part = this.visit(left, parameters, optional);
          right_part = this.visit(right, parameters, optional);
          if (optional && ((this.is_optional_node(left[0]) && !left_part) || ((this.is_optional_node(right[0])) && !right_part))) {
            return "";
          }
          return "" + left_part + right_part;
        case NodeTypes.SYMBOL:
          value = parameters[left];
          delete parameters[left];
          if (value != null) {
            return this.encode_segment(this.path_identifier(value));
          }
          if (optional) {
            return "";
          } else {
            throw new ParameterMissing("Route parameter missing: " + left);
          }
          break;
        default:
          throw new Error("Unknown Rails node type");
      }
    },
    encode_segment: function(segment) {
      return segment.replace(UriEncoderSegmentRegex, function(str) {
        return encodeURIComponent(str);
      });
    },
    is_optional_node: function(node) {
      return this.indexOf([NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT], node) >= 0;
    },
    build_path_spec: function(route, wildcard) {
      var left, right, type;
      if (wildcard == null) {
        wildcard = false;
      }
      type = route[0], left = route[1], right = route[2];
      switch (type) {
        case NodeTypes.GROUP:
          return "(" + (this.build_path_spec(left)) + ")";
        case NodeTypes.CAT:
          return "" + (this.build_path_spec(left)) + (this.build_path_spec(right));
        case NodeTypes.STAR:
          return this.build_path_spec(left, true);
        case NodeTypes.SYMBOL:
          if (wildcard === true) {
            return "" + (left[0] === '*' ? '' : '*') + left;
          } else {
            return ":" + left;
          }
          break;
        case NodeTypes.SLASH:
        case NodeTypes.DOT:
        case NodeTypes.LITERAL:
          return left;
        default:
          throw new Error("Unknown Rails node type");
      }
    },
    visit_globbing: function(route, parameters, optional) {
      var left, right, type, value;
      type = route[0], left = route[1], right = route[2];
      value = parameters[left];
      delete parameters[left];
      if (value == null) {
        return this.visit(route, parameters, optional);
      }
      value = (function() {
        switch (this.get_object_type(value)) {
          case "array":
            return value.join("/");
          default:
            return value;
        }
      }).call(this);
      if (DeprecatedGlobbingBehavior) {
        return this.path_identifier(value);
      } else {
        return encodeURI(this.path_identifier(value));
      }
    },
    get_prefix: function() {
      var prefix;
      prefix = this.configuration.prefix;
      if (prefix !== "") {
        prefix = (prefix.match("/$") ? prefix : prefix + "/");
      }
      return prefix;
    },
    route: function(parts_table, default_options, route_spec, full_url) {
      var j, len, part, parts, path_fn, ref, required, required_parts;
      required_parts = [];
      parts = [];
      for (j = 0, len = parts_table.length; j < len; j++) {
        ref = parts_table[j], part = ref[0], required = ref[1];
        parts.push(part);
        if (required) {
          required_parts.push(part);
        }
      }
      path_fn = function() {
        return Utils.build_route(parts, required_parts, default_options, route_spec, full_url, arguments);
      };
      path_fn.required_params = required_parts;
      path_fn.toString = function() {
        return Utils.build_path_spec(route_spec);
      };
      return path_fn;
    },
    route_url: function(route_defaults) {
      var hostname, port, protocol, subdomain;
      if (typeof route_defaults === 'string') {
        return route_defaults;
      }
      hostname = route_defaults.host || Utils.current_host();
      if (!hostname) {
        return '';
      }
      subdomain = route_defaults.subdomain ? route_defaults.subdomain + '.' : '';
      protocol = route_defaults.protocol || Utils.current_protocol();
      port = route_defaults.port || (!route_defaults.host ? Utils.current_port() : void 0);
      port = port ? ":" + port : '';
      return protocol + "://" + subdomain + hostname + port;
    },
    has_location: function() {
      return (typeof window !== "undefined" && window !== null ? window.location : void 0) != null;
    },
    current_host: function() {
      if (this.has_location()) {
        return window.location.hostname;
      } else {
        return null;
      }
    },
    current_protocol: function() {
      if (this.has_location() && window.location.protocol !== '') {
        return window.location.protocol.replace(/:$/, '');
      } else {
        return 'http';
      }
    },
    current_port: function() {
      if (this.has_location() && window.location.port !== '') {
        return window.location.port;
      } else {
        return '';
      }
    },
    _classToTypeCache: null,
    _classToType: function() {
      var j, len, name, ref;
      if (this._classToTypeCache != null) {
        return this._classToTypeCache;
      }
      this._classToTypeCache = {};
      ref = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
      for (j = 0, len = ref.length; j < len; j++) {
        name = ref[j];
        this._classToTypeCache["[object " + name + "]"] = name.toLowerCase();
      }
      return this._classToTypeCache;
    },
    get_object_type: function(obj) {
      if (this.jQuery && (this.jQuery.type != null)) {
        return this.jQuery.type(obj);
      }
      if (obj == null) {
        return "" + obj;
      }
      if (typeof obj === "object" || typeof obj === "function") {
        return this._classToType()[Object.prototype.toString.call(obj)] || "object";
      } else {
        return typeof obj;
      }
    },
    indexOf: function(array, element) {
      if (Array.prototype.indexOf) {
        return array.indexOf(element);
      } else {
        return this.indexOfImplementation(array, element);
      }
    },
    indexOfImplementation: function(array, element) {
      var el, i, j, len, result;
      result = -1;
      for (i = j = 0, len = array.length; j < len; i = ++j) {
        el = array[i];
        if (el === element) {
          result = i;
        }
      }
      return result;
    },
    namespace: function(root, namespace, routes) {
      var index, j, len, part, parts;
      parts = namespace ? namespace.split(".") : [];
      if (parts.length === 0) {
        return routes;
      }
      for (index = j = 0, len = parts.length; j < len; index = ++j) {
        part = parts[index];
        if (index < parts.length - 1) {
          root = (root[part] || (root[part] = {}));
        } else {
          return root[part] = routes;
        }
      }
    },
    configure: function(new_config) {
      return this.configuration = this.merge(this.configuration, new_config);
    },
    config: function() {
      return this.clone(this.configuration);
    },
    make: function() {
      var routes;
      routes = {
// absent_user => /users/:id/absent(.:format)
  // function(id, options)
  absent_user_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"absent",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// activate_admin_location => /admin/locations/:id/activate(.:format)
  // function(id, options)
  activate_admin_location_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"locations",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"activate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// activate_company => /companies/:id/activate(.:format)
  // function(id, options)
  activate_company_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"companies",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"activate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// activate_costcenter => /costcenters/:id/activate(.:format)
  // function(id, options)
  activate_costcenter_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"costcenters",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"activate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// activate_machine => /machines/:id/activate(.:format)
  // function(id, options)
  activate_machine_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"activate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// activate_machine_machine_process => /machines/:machine_id/machine_processes/:id/activate(.:format)
  // function(machine_id, id, options)
  activate_machine_machine_process_path: Utils.route([["machine_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"machine_processes",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"activate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// activate_material_type => /material_types/:id/activate(.:format)
  // function(id, options)
  activate_material_type_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_types",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"activate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// activate_parameter => /parameters/:id/activate(.:format)
  // function(id, options)
  activate_parameter_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"parameters",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"activate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// activate_process_item => /process_items/:id/activate(.:format)
  // function(id, options)
  activate_process_item_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"process_items",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"activate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// activate_recipe => /recipes/:id/activate(.:format)
  // function(id, options)
  activate_recipe_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"recipes",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"activate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// activate_user => /users/:id/activate(.:format)
  // function(id, options)
  activate_user_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"activate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_configurable => /admin/configurable(.:format)
  // function(options)
  admin_configurable_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"configurable",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// admin_location => /admin/locations/:id(.:format)
  // function(id, options)
  admin_location_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"locations",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_locations => /admin/locations(.:format)
  // function(options)
  admin_locations_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"locations",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// admin_reservation_queue => /admin/reservation_queues/:id(.:format)
  // function(id, options)
  admin_reservation_queue_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"reservation_queues",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_reservation_queues => /admin/reservation_queues(.:format)
  // function(options)
  admin_reservation_queues_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"reservation_queues",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// admin_user_group => /admin/user_groups/:id(.:format)
  // function(id, options)
  admin_user_group_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"user_groups",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// admin_user_group_user_group_membership => /admin/user_groups/:user_group_id/user_group_memberships/:id(.:format)
  // function(user_group_id, id, options)
  admin_user_group_user_group_membership_path: Utils.route([["user_group_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"user_groups",false],[2,[7,"/",false],[2,[3,"user_group_id",false],[2,[7,"/",false],[2,[6,"user_group_memberships",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// admin_user_group_user_group_memberships => /admin/user_groups/:user_group_id/user_group_memberships(.:format)
  // function(user_group_id, options)
  admin_user_group_user_group_memberships_path: Utils.route([["user_group_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"user_groups",false],[2,[7,"/",false],[2,[3,"user_group_id",false],[2,[7,"/",false],[2,[6,"user_group_memberships",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// admin_user_groups => /admin/user_groups(.:format)
  // function(options)
  admin_user_groups_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"user_groups",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// api_editor_abstract_run => /api/editor/abstract_runs/:id(.:format)
  // function(id, options)
  api_editor_abstract_run_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"editor",false],[2,[7,"/",false],[2,[6,"abstract_runs",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// api_editor_abstract_run_run_item => /api/editor/abstract_runs/:abstract_run_id/run_items/:id(.:format)
  // function(abstract_run_id, id, options)
  api_editor_abstract_run_run_item_path: Utils.route([["abstract_run_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"editor",false],[2,[7,"/",false],[2,[6,"abstract_runs",false],[2,[7,"/",false],[2,[3,"abstract_run_id",false],[2,[7,"/",false],[2,[6,"run_items",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// api_editor_abstract_run_run_item_file => /api/editor/abstract_runs/:abstract_run_id/run_item_files/:id(.:format)
  // function(abstract_run_id, id, options)
  api_editor_abstract_run_run_item_file_path: Utils.route([["abstract_run_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"editor",false],[2,[7,"/",false],[2,[6,"abstract_runs",false],[2,[7,"/",false],[2,[3,"abstract_run_id",false],[2,[7,"/",false],[2,[6,"run_item_files",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// api_editor_abstract_run_run_item_files => /api/editor/abstract_runs/:abstract_run_id/run_item_files(.:format)
  // function(abstract_run_id, options)
  api_editor_abstract_run_run_item_files_path: Utils.route([["abstract_run_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"editor",false],[2,[7,"/",false],[2,[6,"abstract_runs",false],[2,[7,"/",false],[2,[3,"abstract_run_id",false],[2,[7,"/",false],[2,[6,"run_item_files",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// api_editor_abstract_run_run_items => /api/editor/abstract_runs/:abstract_run_id/run_items(.:format)
  // function(abstract_run_id, options)
  api_editor_abstract_run_run_items_path: Utils.route([["abstract_run_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"editor",false],[2,[7,"/",false],[2,[6,"abstract_runs",false],[2,[7,"/",false],[2,[3,"abstract_run_id",false],[2,[7,"/",false],[2,[6,"run_items",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// api_editor_abstract_run_withdrawals => /api/editor/abstract_runs/:abstract_run_id/withdrawals(.:format)
  // function(abstract_run_id, options)
  api_editor_abstract_run_withdrawals_path: Utils.route([["abstract_run_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"editor",false],[2,[7,"/",false],[2,[6,"abstract_runs",false],[2,[7,"/",false],[2,[3,"abstract_run_id",false],[2,[7,"/",false],[2,[6,"withdrawals",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// api_editor_master_data => /api/editor/master_data(.:format)
  // function(options)
  api_editor_master_data_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"editor",false],[2,[7,"/",false],[2,[6,"master_data",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// api_editor_reservation_queue => /api/editor/reservation_queues/:id(.:format)
  // function(id, options)
  api_editor_reservation_queue_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"editor",false],[2,[7,"/",false],[2,[6,"reservation_queues",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// assigned_users_reservation => /reservations/:id/assigned_users(.:format)
  // function(id, options)
  assigned_users_reservation_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"reservations",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"assigned_users",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// change_log => /change_logs/:id(.:format)
  // function(id, options)
  change_log_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"change_logs",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// change_logs => /change_logs(.:format)
  // function(options)
  change_logs_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"change_logs",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// companies => /companies(.:format)
  // function(options)
  companies_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"companies",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// company => /companies/:id(.:format)
  // function(id, options)
  company_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"companies",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// costcenter => /costcenters/:id(.:format)
  // function(id, options)
  costcenter_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"costcenters",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// costcenters => /costcenters(.:format)
  // function(options)
  costcenters_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"costcenters",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// create_overtime_balance_user_time_accounting_adapts => /users/:user_id/time_accounting_adapts/create_overtime_balance(.:format)
  // function(user_id, options)
  create_overtime_balance_user_time_accounting_adapts_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"time_accounting_adapts",false],[2,[7,"/",false],[2,[6,"create_overtime_balance",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// deactivate_admin_location => /admin/locations/:id/deactivate(.:format)
  // function(id, options)
  deactivate_admin_location_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"locations",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"deactivate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// deactivate_company => /companies/:id/deactivate(.:format)
  // function(id, options)
  deactivate_company_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"companies",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"deactivate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// deactivate_costcenter => /costcenters/:id/deactivate(.:format)
  // function(id, options)
  deactivate_costcenter_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"costcenters",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"deactivate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// deactivate_machine => /machines/:id/deactivate(.:format)
  // function(id, options)
  deactivate_machine_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"deactivate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// deactivate_machine_machine_process => /machines/:machine_id/machine_processes/:id/deactivate(.:format)
  // function(machine_id, id, options)
  deactivate_machine_machine_process_path: Utils.route([["machine_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"machine_processes",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"deactivate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// deactivate_material_type => /material_types/:id/deactivate(.:format)
  // function(id, options)
  deactivate_material_type_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_types",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"deactivate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// deactivate_parameter => /parameters/:id/deactivate(.:format)
  // function(id, options)
  deactivate_parameter_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"parameters",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"deactivate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// deactivate_process_item => /process_items/:id/deactivate(.:format)
  // function(id, options)
  deactivate_process_item_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"process_items",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"deactivate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// deactivate_recipe => /recipes/:id/deactivate(.:format)
  // function(id, options)
  deactivate_recipe_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"recipes",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"deactivate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// deactivate_user => /users/:id/deactivate(.:format)
  // function(id, options)
  deactivate_user_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"deactivate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_admin_configurable => /admin/configurable/edit(.:format)
  // function(options)
  edit_admin_configurable_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"configurable",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_admin_location => /admin/locations/:id/edit(.:format)
  // function(id, options)
  edit_admin_location_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"locations",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_admin_reservation_queue => /admin/reservation_queues/:id/edit(.:format)
  // function(id, options)
  edit_admin_reservation_queue_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"reservation_queues",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_admin_user_group => /admin/user_groups/:id/edit(.:format)
  // function(id, options)
  edit_admin_user_group_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"user_groups",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_company => /companies/:id/edit(.:format)
  // function(id, options)
  edit_company_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"companies",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_costcenter => /costcenters/:id/edit(.:format)
  // function(id, options)
  edit_costcenter_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"costcenters",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_holiday => /holidays/:id/edit(.:format)
  // function(id, options)
  edit_holiday_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"holidays",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_machine => /machines/:id/edit(.:format)
  // function(id, options)
  edit_machine_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_machine_configurable_attributes => /machines/:machine_id/configurable_attributes/edit(.:format)
  // function(machine_id, options)
  edit_machine_configurable_attributes_path: Utils.route([["machine_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"configurable_attributes",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_machine_machine_process => /machines/:machine_id/machine_processes/:id/edit(.:format)
  // function(machine_id, id, options)
  edit_machine_machine_process_path: Utils.route([["machine_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"machine_processes",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_machine_price => /machines/:machine_id/prices/:id/edit(.:format)
  // function(machine_id, id, options)
  edit_machine_price_path: Utils.route([["machine_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"prices",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_material_delivery => /material_deliveries/:id/edit(.:format)
  // function(id, options)
  edit_material_delivery_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_material_delivery_material_lot => /material_deliveries/:material_delivery_id/material_lots/:id/edit(.:format)
  // function(material_delivery_id, id, options)
  edit_material_delivery_material_lot_path: Utils.route([["material_delivery_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_material_delivery_material_lot_material_withdrawal => /material_deliveries/:material_delivery_id/material_lots/:material_lot_id/material_withdrawals/:id/edit(.:format)
  // function(material_delivery_id, material_lot_id, id, options)
  edit_material_delivery_material_lot_material_withdrawal_path: Utils.route([["material_delivery_id",true],["material_lot_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[3,"material_lot_id",false],[2,[7,"/",false],[2,[6,"material_withdrawals",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]]]),
// edit_material_lot_configurable_attributes => /material_lots/:material_lot_id/configurable_attributes/edit(.:format)
  // function(material_lot_id, options)
  edit_material_lot_configurable_attributes_path: Utils.route([["material_lot_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[3,"material_lot_id",false],[2,[7,"/",false],[2,[6,"configurable_attributes",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_material_type => /material_types/:id/edit(.:format)
  // function(id, options)
  edit_material_type_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_types",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_parameter => /parameters/:id/edit(.:format)
  // function(id, options)
  edit_parameter_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"parameters",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_parameter_group => /parameter_groups/:id/edit(.:format)
  // function(id, options)
  edit_parameter_group_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"parameter_groups",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_parameter_group_configuration => /parameter_group_configurations/:id/edit(.:format)
  // function(id, options)
  edit_parameter_group_configuration_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"parameter_group_configurations",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_password_reset => /password_resets/:id/edit(.:format)
  // function(id, options)
  edit_password_reset_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"password_resets",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_post => /posts/:id/edit(.:format)
  // function(id, options)
  edit_post_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"posts",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_process_item => /process_items/:id/edit(.:format)
  // function(id, options)
  edit_process_item_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"process_items",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_recipe => /recipes/:id/edit(.:format)
  // function(id, options)
  edit_recipe_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"recipes",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_reservation => /reservations/:id/edit(.:format)
  // function(id, options)
  edit_reservation_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"reservations",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_run => /runs/:id/edit(.:format)
  // function(id, options)
  edit_run_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"runs",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_run_configurable_attributes => /runs/:run_id/configurable_attributes/edit(.:format)
  // function(run_id, options)
  edit_run_configurable_attributes_path: Utils.route([["run_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"runs",false],[2,[7,"/",false],[2,[3,"run_id",false],[2,[7,"/",false],[2,[6,"configurable_attributes",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_run_template => /run_templates/:id/edit(.:format)
  // function(id, options)
  edit_run_template_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"run_templates",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_run_template_configurable_attributes => /run_templates/:run_template_id/configurable_attributes/edit(.:format)
  // function(run_template_id, options)
  edit_run_template_configurable_attributes_path: Utils.route([["run_template_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"run_templates",false],[2,[7,"/",false],[2,[3,"run_template_id",false],[2,[7,"/",false],[2,[6,"configurable_attributes",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_user => /users/:id/edit(.:format)
  // function(id, options)
  edit_user_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_user_absence => /users/:user_id/absences/:id/edit(.:format)
  // function(user_id, id, options)
  edit_user_absence_path: Utils.route([["user_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"absences",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_user_schedule => /users/:user_id/schedules/:id/edit(.:format)
  // function(user_id, id, options)
  edit_user_schedule_path: Utils.route([["user_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"schedules",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_user_task => /users/:user_id/tasks/:id/edit(.:format)
  // function(user_id, id, options)
  edit_user_task_path: Utils.route([["user_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"tasks",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_user_time_accounting_adapt => /users/:user_id/time_accounting_adapts/:id/edit(.:format)
  // function(user_id, id, options)
  edit_user_time_accounting_adapt_path: Utils.route([["user_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"time_accounting_adapts",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_user_working_time_account => /users/:user_id/working_time_account/edit(.:format)
  // function(user_id, options)
  edit_user_working_time_account_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"working_time_account",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// events_machine => /machines/:id/events(.:format)
  // function(id, options)
  events_machine_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"events",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// events_user => /users/:id/events(.:format)
  // function(id, options)
  events_user_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"events",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// exception_notifier_test => /exception_notifier_test(.:format)
  // function(options)
  exception_notifier_test_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"exception_notifier_test",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// export_export => /export/export(.:format)
  // function(options)
  export_export_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"export",false],[2,[7,"/",false],[2,[6,"export",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// export_material_withdrawals => /export/material_withdrawals(.:format)
  // function(options)
  export_material_withdrawals_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"export",false],[2,[7,"/",false],[2,[6,"material_withdrawals",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// export_reservations => /export/reservations(.:format)
  // function(options)
  export_reservations_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"export",false],[2,[7,"/",false],[2,[6,"reservations",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// export_tasks => /export/tasks(.:format)
  // function(options)
  export_tasks_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"export",false],[2,[7,"/",false],[2,[6,"tasks",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// holiday => /holidays/:id(.:format)
  // function(id, options)
  holiday_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"holidays",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// holidays => /holidays(.:format)
  // function(options)
  holidays_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"holidays",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// icalendar_absences => /icalendar/absences(.:format)
  // function(options)
  icalendar_absences_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"icalendar",false],[2,[7,"/",false],[2,[6,"absences",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// login => /login(.:format)
  // function(options)
  login_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"login",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// logout => /logout(.:format)
  // function(options)
  logout_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"logout",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// machine => /machines/:id(.:format)
  // function(id, options)
  machine_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// machine_configurable_attributes => /machines/:machine_id/configurable_attributes(.:format)
  // function(machine_id, options)
  machine_configurable_attributes_path: Utils.route([["machine_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"configurable_attributes",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// machine_machine_process => /machines/:machine_id/machine_processes/:id(.:format)
  // function(machine_id, id, options)
  machine_machine_process_path: Utils.route([["machine_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"machine_processes",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// machine_machine_processes => /machines/:machine_id/machine_processes(.:format)
  // function(machine_id, options)
  machine_machine_processes_path: Utils.route([["machine_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"machine_processes",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// machine_price => /machines/:machine_id/prices/:id(.:format)
  // function(machine_id, id, options)
  machine_price_path: Utils.route([["machine_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"prices",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// machine_prices => /machines/:machine_id/prices(.:format)
  // function(machine_id, options)
  machine_prices_path: Utils.route([["machine_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"prices",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// machine_process_form_reservation => /reservations/:id/machine_process_form(.:format)
  // function(id, options)
  machine_process_form_reservation_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"reservations",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"machine_process_form",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// machine_reservations => /machines/:machine_id/reservations(.:format)
  // function(machine_id, options)
  machine_reservations_path: Utils.route([["machine_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"reservations",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// machines => /machines(.:format)
  // function(options)
  machines_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// material_deliveries => /material_deliveries(.:format)
  // function(options)
  material_deliveries_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// material_delivery => /material_deliveries/:id(.:format)
  // function(id, options)
  material_delivery_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// material_delivery_material_document => /material_deliveries/:material_delivery_id/material_documents/:id(.:format)
  // function(material_delivery_id, id, options)
  material_delivery_material_document_path: Utils.route([["material_delivery_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_documents",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// material_delivery_material_documents => /material_deliveries/:material_delivery_id/material_documents(.:format)
  // function(material_delivery_id, options)
  material_delivery_material_documents_path: Utils.route([["material_delivery_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_documents",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// material_delivery_material_lot => /material_deliveries/:material_delivery_id/material_lots/:id(.:format)
  // function(material_delivery_id, id, options)
  material_delivery_material_lot_path: Utils.route([["material_delivery_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// material_delivery_material_lot_material_document => /material_deliveries/:material_delivery_id/material_lots/:material_lot_id/material_documents/:id(.:format)
  // function(material_delivery_id, material_lot_id, id, options)
  material_delivery_material_lot_material_document_path: Utils.route([["material_delivery_id",true],["material_lot_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[3,"material_lot_id",false],[2,[7,"/",false],[2,[6,"material_documents",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// material_delivery_material_lot_material_documents => /material_deliveries/:material_delivery_id/material_lots/:material_lot_id/material_documents(.:format)
  // function(material_delivery_id, material_lot_id, options)
  material_delivery_material_lot_material_documents_path: Utils.route([["material_delivery_id",true],["material_lot_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[3,"material_lot_id",false],[2,[7,"/",false],[2,[6,"material_documents",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// material_delivery_material_lot_material_withdrawal => /material_deliveries/:material_delivery_id/material_lots/:material_lot_id/material_withdrawals/:id(.:format)
  // function(material_delivery_id, material_lot_id, id, options)
  material_delivery_material_lot_material_withdrawal_path: Utils.route([["material_delivery_id",true],["material_lot_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[3,"material_lot_id",false],[2,[7,"/",false],[2,[6,"material_withdrawals",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// material_delivery_material_lot_material_withdrawals => /material_deliveries/:material_delivery_id/material_lots/:material_lot_id/material_withdrawals(.:format)
  // function(material_delivery_id, material_lot_id, options)
  material_delivery_material_lot_material_withdrawals_path: Utils.route([["material_delivery_id",true],["material_lot_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[3,"material_lot_id",false],[2,[7,"/",false],[2,[6,"material_withdrawals",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// material_delivery_material_lots => /material_deliveries/:material_delivery_id/material_lots(.:format)
  // function(material_delivery_id, options)
  material_delivery_material_lots_path: Utils.route([["material_delivery_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_lots",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// material_imports => /material_imports(.:format)
  // function(options)
  material_imports_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"material_imports",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// material_lot_configurable_attributes => /material_lots/:material_lot_id/configurable_attributes(.:format)
  // function(material_lot_id, options)
  material_lot_configurable_attributes_path: Utils.route([["material_lot_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[3,"material_lot_id",false],[2,[7,"/",false],[2,[6,"configurable_attributes",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// material_type => /material_types/:id(.:format)
  // function(id, options)
  material_type_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_types",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// material_types => /material_types(.:format)
  // function(options)
  material_types_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"material_types",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// materials => /materials(.:format)
  // function(options)
  materials_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"materials",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// new_admin_configurable => /admin/configurable/new(.:format)
  // function(options)
  new_admin_configurable_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"configurable",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_admin_location => /admin/locations/new(.:format)
  // function(options)
  new_admin_location_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"locations",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_admin_reservation_queue => /admin/reservation_queues/new(.:format)
  // function(options)
  new_admin_reservation_queue_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"reservation_queues",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_admin_user_group => /admin/user_groups/new(.:format)
  // function(options)
  new_admin_user_group_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"user_groups",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_company => /companies/new(.:format)
  // function(options)
  new_company_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"companies",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_costcenter => /costcenters/new(.:format)
  // function(options)
  new_costcenter_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"costcenters",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_holiday => /holidays/new(.:format)
  // function(options)
  new_holiday_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"holidays",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_machine => /machines/new(.:format)
  // function(options)
  new_machine_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_machine_machine_process => /machines/:machine_id/machine_processes/new(.:format)
  // function(machine_id, options)
  new_machine_machine_process_path: Utils.route([["machine_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"machine_processes",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// new_machine_price => /machines/:machine_id/prices/new(.:format)
  // function(machine_id, options)
  new_machine_price_path: Utils.route([["machine_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"machines",false],[2,[7,"/",false],[2,[3,"machine_id",false],[2,[7,"/",false],[2,[6,"prices",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// new_material_delivery => /material_deliveries/new(.:format)
  // function(options)
  new_material_delivery_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_material_delivery_material_document => /material_deliveries/:material_delivery_id/material_documents/new(.:format)
  // function(material_delivery_id, options)
  new_material_delivery_material_document_path: Utils.route([["material_delivery_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_documents",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// new_material_delivery_material_lot => /material_deliveries/:material_delivery_id/material_lots/new(.:format)
  // function(material_delivery_id, options)
  new_material_delivery_material_lot_path: Utils.route([["material_delivery_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// new_material_delivery_material_lot_material_document => /material_deliveries/:material_delivery_id/material_lots/:material_lot_id/material_documents/new(.:format)
  // function(material_delivery_id, material_lot_id, options)
  new_material_delivery_material_lot_material_document_path: Utils.route([["material_delivery_id",true],["material_lot_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[3,"material_lot_id",false],[2,[7,"/",false],[2,[6,"material_documents",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// new_material_delivery_material_lot_material_withdrawal => /material_deliveries/:material_delivery_id/material_lots/:material_lot_id/material_withdrawals/new(.:format)
  // function(material_delivery_id, material_lot_id, options)
  new_material_delivery_material_lot_material_withdrawal_path: Utils.route([["material_delivery_id",true],["material_lot_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"material_deliveries",false],[2,[7,"/",false],[2,[3,"material_delivery_id",false],[2,[7,"/",false],[2,[6,"material_lots",false],[2,[7,"/",false],[2,[3,"material_lot_id",false],[2,[7,"/",false],[2,[6,"material_withdrawals",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// new_material_import => /material_imports/new(.:format)
  // function(options)
  new_material_import_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"material_imports",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_material_type => /material_types/new(.:format)
  // function(options)
  new_material_type_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"material_types",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_parameter => /parameters/new(.:format)
  // function(options)
  new_parameter_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"parameters",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_parameter_group => /parameter_groups/new(.:format)
  // function(options)
  new_parameter_group_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"parameter_groups",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_parameter_group_configuration => /parameter_group_configurations/new(.:format)
  // function(options)
  new_parameter_group_configuration_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"parameter_group_configurations",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_password_reset => /password_resets/new(.:format)
  // function(options)
  new_password_reset_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"password_resets",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_post => /posts/new(.:format)
  // function(options)
  new_post_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"posts",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_process_item => /process_items/new(.:format)
  // function(options)
  new_process_item_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"process_items",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_recipe => /recipes/new(.:format)
  // function(options)
  new_recipe_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"recipes",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_reservation => /reservations/new(.:format)
  // function(options)
  new_reservation_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"reservations",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_run => /runs/new(.:format)
  // function(options)
  new_run_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"runs",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_run_template => /run_templates/new(.:format)
  // function(options)
  new_run_template_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"run_templates",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_uploaded_document => /uploaded_documents/new(.:format)
  // function(options)
  new_uploaded_document_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"uploaded_documents",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_user => /users/new(.:format)
  // function(options)
  new_user_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_user_absence => /users/:user_id/absences/new(.:format)
  // function(user_id, options)
  new_user_absence_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"absences",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// new_user_schedule => /users/:user_id/schedules/new(.:format)
  // function(user_id, options)
  new_user_schedule_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"schedules",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// new_user_task => /users/:user_id/tasks/new(.:format)
  // function(user_id, options)
  new_user_task_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"tasks",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// new_user_time_accounting_adapt => /users/:user_id/time_accounting_adapts/new(.:format)
  // function(user_id, options)
  new_user_time_accounting_adapt_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"time_accounting_adapts",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// new_user_working_time_account => /users/:user_id/working_time_account/new(.:format)
  // function(user_id, options)
  new_user_working_time_account_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"working_time_account",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// parameter => /parameters/:id(.:format)
  // function(id, options)
  parameter_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"parameters",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// parameter_group => /parameter_groups/:id(.:format)
  // function(id, options)
  parameter_group_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"parameter_groups",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// parameter_group_configuration => /parameter_group_configurations/:id(.:format)
  // function(id, options)
  parameter_group_configuration_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"parameter_group_configurations",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// parameter_group_configurations => /parameter_group_configurations(.:format)
  // function(options)
  parameter_group_configurations_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"parameter_group_configurations",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// parameter_groups => /parameter_groups(.:format)
  // function(options)
  parameter_groups_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"parameter_groups",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// parameters => /parameters(.:format)
  // function(options)
  parameters_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"parameters",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// password_reset => /password_resets/:id(.:format)
  // function(id, options)
  password_reset_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"password_resets",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// password_resets => /password_resets(.:format)
  // function(options)
  password_resets_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"password_resets",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// post => /posts/:id(.:format)
  // function(id, options)
  post_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"posts",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// posts => /posts(.:format)
  // function(options)
  posts_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"posts",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// process_item => /process_items/:id(.:format)
  // function(id, options)
  process_item_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"process_items",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// process_items => /process_items(.:format)
  // function(options)
  process_items_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"process_items",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// profile => /profile(.:format)
  // function(options)
  profile_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"profile",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// quick_login => /quick_login(.:format)
  // function(options)
  quick_login_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"quick_login",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// rails_blob_representation => /rails/active_storage/representations/:signed_blob_id/:variation_key/*filename(.:format)
  // function(signed_blob_id, variation_key, filename, options)
  rails_blob_representation_path: Utils.route([["signed_blob_id",true],["variation_key",true],["filename",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"representations",false],[2,[7,"/",false],[2,[3,"signed_blob_id",false],[2,[7,"/",false],[2,[3,"variation_key",false],[2,[7,"/",false],[2,[5,[3,"filename",false],false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// rails_direct_uploads => /rails/active_storage/direct_uploads(.:format)
  // function(options)
  rails_direct_uploads_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"direct_uploads",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// rails_disk_service => /rails/active_storage/disk/:encoded_key/*filename(.:format)
  // function(encoded_key, filename, options)
  rails_disk_service_path: Utils.route([["encoded_key",true],["filename",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"disk",false],[2,[7,"/",false],[2,[3,"encoded_key",false],[2,[7,"/",false],[2,[5,[3,"filename",false],false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// rails_service_blob => /rails/active_storage/blobs/:signed_id/*filename(.:format)
  // function(signed_id, filename, options)
  rails_service_blob_path: Utils.route([["signed_id",true],["filename",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"blobs",false],[2,[7,"/",false],[2,[3,"signed_id",false],[2,[7,"/",false],[2,[5,[3,"filename",false],false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// recipe => /recipes/:id(.:format)
  // function(id, options)
  recipe_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"recipes",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// recipes => /recipes(.:format)
  // function(options)
  recipes_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"recipes",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// reservation => /reservations/:id(.:format)
  // function(id, options)
  reservation_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"reservations",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// reservation_copy => /reservations/:reservation_id/copy(.:format)
  // function(reservation_id, options)
  reservation_copy_path: Utils.route([["reservation_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"reservations",false],[2,[7,"/",false],[2,[3,"reservation_id",false],[2,[7,"/",false],[2,[6,"copy",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// reservation_queue => /reservation_queues/:id(.:format)
  // function(id, options)
  reservation_queue_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"reservation_queues",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// reservation_queues => /reservation_queues(.:format)
  // function(options)
  reservation_queues_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"reservation_queues",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// reservations => /reservations(.:format)
  // function(options)
  reservations_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"reservations",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// reservations_user => /users/:id/reservations(.:format)
  // function(id, options)
  reservations_user_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"reservations",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// root => /
  // function(options)
  root_path: Utils.route([], {}, [7,"/",false]),
// run => /runs/:id(.:format)
  // function(id, options)
  run_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"runs",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// run_configurable_attributes => /runs/:run_id/configurable_attributes(.:format)
  // function(run_id, options)
  run_configurable_attributes_path: Utils.route([["run_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"runs",false],[2,[7,"/",false],[2,[3,"run_id",false],[2,[7,"/",false],[2,[6,"configurable_attributes",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// run_costs => /runs/:run_id/costs(.:format)
  // function(run_id, options)
  run_costs_path: Utils.route([["run_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"runs",false],[2,[7,"/",false],[2,[3,"run_id",false],[2,[7,"/",false],[2,[6,"costs",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// run_material_withdrawals => /runs/:run_id/material_withdrawals(.:format)
  // function(run_id, options)
  run_material_withdrawals_path: Utils.route([["run_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"runs",false],[2,[7,"/",false],[2,[3,"run_id",false],[2,[7,"/",false],[2,[6,"material_withdrawals",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// run_materials => /runs/:run_id/materials(.:format)
  // function(run_id, options)
  run_materials_path: Utils.route([["run_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"runs",false],[2,[7,"/",false],[2,[3,"run_id",false],[2,[7,"/",false],[2,[6,"materials",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// run_reservations => /runs/:run_id/reservations(.:format)
  // function(run_id, options)
  run_reservations_path: Utils.route([["run_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"runs",false],[2,[7,"/",false],[2,[3,"run_id",false],[2,[7,"/",false],[2,[6,"reservations",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// run_template => /run_templates/:id(.:format)
  // function(id, options)
  run_template_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"run_templates",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// run_template_configurable_attributes => /run_templates/:run_template_id/configurable_attributes(.:format)
  // function(run_template_id, options)
  run_template_configurable_attributes_path: Utils.route([["run_template_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"run_templates",false],[2,[7,"/",false],[2,[3,"run_template_id",false],[2,[7,"/",false],[2,[6,"configurable_attributes",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// run_templates => /run_templates(.:format)
  // function(options)
  run_templates_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"run_templates",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// runs => /runs(.:format)
  // function(options)
  runs_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"runs",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// tasks => /tasks(.:format)
  // function(options)
  tasks_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"tasks",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// tasks_stats_user => /users/:id/tasks_stats(.:format)
  // function(id, options)
  tasks_stats_user_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"tasks_stats",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// update_rails_disk_service => /rails/active_storage/disk/:encoded_token(.:format)
  // function(encoded_token, options)
  update_rails_disk_service_path: Utils.route([["encoded_token",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"disk",false],[2,[7,"/",false],[2,[3,"encoded_token",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// update_state_reservation => /reservations/:id/update_state(.:format)
  // function(id, options)
  update_state_reservation_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"reservations",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"update_state",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// update_state_reservation_assignment => /reservation_assignments/:id/update_state(.:format)
  // function(id, options)
  update_state_reservation_assignment_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"reservation_assignments",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"update_state",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// update_state_run => /runs/:id/update_state(.:format)
  // function(id, options)
  update_state_run_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"runs",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"update_state",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// update_state_run_template => /run_templates/:id/update_state(.:format)
  // function(id, options)
  update_state_run_template_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"run_templates",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"update_state",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// update_state_user_task => /users/:user_id/tasks/:id/update_state(.:format)
  // function(user_id, id, options)
  update_state_user_task_path: Utils.route([["user_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"tasks",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"update_state",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// uploaded_document => /uploaded_documents/:id(.:format)
  // function(id, options)
  uploaded_document_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"uploaded_documents",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// uploaded_documents => /uploaded_documents(.:format)
  // function(options)
  uploaded_documents_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"uploaded_documents",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// user => /users/:id(.:format)
  // function(id, options)
  user_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// user_absence => /users/:user_id/absences/:id(.:format)
  // function(user_id, id, options)
  user_absence_path: Utils.route([["user_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"absences",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// user_absences => /users/:user_id/absences(.:format)
  // function(user_id, options)
  user_absences_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"absences",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// user_calendar_schedule => /users/:user_id/calendar_schedule(.:format)
  // function(user_id, options)
  user_calendar_schedule_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"calendar_schedule",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// user_duties => /users/:user_id/duties(.:format)
  // function(user_id, options)
  user_duties_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"duties",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// user_reservation => /users/:user_id/reservations/:id(.:format)
  // function(user_id, id, options)
  user_reservation_path: Utils.route([["user_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"reservations",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// user_schedule => /users/:user_id/schedules/:id(.:format)
  // function(user_id, id, options)
  user_schedule_path: Utils.route([["user_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"schedules",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// user_schedules => /users/:user_id/schedules(.:format)
  // function(user_id, options)
  user_schedules_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"schedules",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// user_task => /users/:user_id/tasks/:id(.:format)
  // function(user_id, id, options)
  user_task_path: Utils.route([["user_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"tasks",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// user_tasks => /users/:user_id/tasks(.:format)
  // function(user_id, options)
  user_tasks_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"tasks",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// user_time_accounting_adapt => /users/:user_id/time_accounting_adapts/:id(.:format)
  // function(user_id, id, options)
  user_time_accounting_adapt_path: Utils.route([["user_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"time_accounting_adapts",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// user_time_accounting_adapts => /users/:user_id/time_accounting_adapts(.:format)
  // function(user_id, options)
  user_time_accounting_adapts_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"time_accounting_adapts",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// user_working_time_account => /users/:user_id/working_time_account(.:format)
  // function(user_id, options)
  user_working_time_account_path: Utils.route([["user_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"user_id",false],[2,[7,"/",false],[2,[6,"working_time_account",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// users => /users(.:format)
  // function(options)
  users_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// version_history => /version_history(.:format)
  // function(options)
  version_history_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"version_history",false],[1,[2,[8,".",false],[3,"format",false]],false]]])}
;
      routes.configure = function(config) {
        return Utils.configure(config);
      };
      routes.config = function() {
        return Utils.config();
      };
      routes.default_serializer = function(object, prefix) {
        return Utils.default_serializer(object, prefix);
      };
      return Object.assign({
        "default": routes
      }, routes);
    }
  };

  result = Utils.make();

  if (typeof define === "function" && define.amd) {
    define([], function() {
      return result;
    });
  } else if (typeof module !== "undefined" && module !== null) {
    try {
      module.exports = result;
    } catch (error1) {
      error = error1;
      if (error.name !== 'TypeError') {
        throw error;
      }
    }
  } else {
    Utils.namespace(this, null, result);
  }

  return result;

}).call(this);

